<template>
  
  <div class="container">

    <div class="row" id="media">

        <div class="col-lg-8 mt-0">
            <h2 class="h3">{{ $t("media_title") }}</h2>
            <p class="ontario-lead-statement mb-0">{{ $t("media_description") }}</p>
        </div><!-- col-lg-8 -->
       
        <hr class="bold_hr_super ml-3 mr-3">

    </div><!-- row -->

    <section v-if="errored">
        <p>{{ $t("message_error") }}</p>
    </section>

    <section v-else>

      <div class="row pl-0 pr-0">

        <div class="col-lg-8">
          
          <h3 class="h4">{{ $t("media_advisories_title") }}</h3>
          <p v-html="advisoriesDescription"></p>
          <hr />

          <h3 class="h4">{{ $t("media_contacts_title") }}</h3>
          <p v-html="contactsDescription"></p>
          <hr />

          <!-- <h3 class="h4">{{ $t("media_electronic_title") }}</h3>
          <p>{{ $t("media_electronic_description") }}</p>
          <hr /> -->

          <h3 class="h4">{{ $t("media_bulletins_title") }}</h3>
          <p v-html="bulletinsDescription"></p>
          <hr />
          
        </div><!-- col-lg-8 -->

        <div class="col-lg-4">

          <h3 class="h4">{{ $t("advisories_latest_title") }}</h3>
          <advisories :pagination="false" :type="2002" :limit="3" :page="1"></advisories>   

        </div><!-- col-lg-4 -->

      </div><!-- row -->

    </section>

  </div>

</template>

<script>
import Advisories from '../components/Advisories.vue'

export default {
  components: {
    Advisories
  },
  data () {
    return {
      language: 'en',
      errored: false,
      advisoriesDescription: this.$t('media_advisories_description'),
      bulletinsDescription: this.$t('media_bulletins_description'),
      contactsDescription: this.$t('media_contacts_description')
    }
  }
}
</script>
